import React, { useState, useEffect, useRef } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Skeleton from "react-loading-skeleton";
// import Logo from '../assets/images/logo.svg'
// import MenuBg from '../assets/images/mwnu-img.png'
import Search from "../assets/images/search.svg";
import SidebarSearchIcon from "../assets/images/sidebar-search-icon.svg";
// import SearchItemImg from '../assets/images/search-itme.png'
import Cart from "../assets/images/cart.svg";
import Like from "../assets/images/like.svg";
import User from "../assets/images/user.svg";
import Facebook from "../assets/images/facebook.svg";
import Twitter from "../assets/images/twitter.svg";
import Linkedin from "../assets/images/linkedin.svg";
import Instagram from "../assets/images/instagram.svg";
import Youtube from "../assets/images/youtube.svg";
import whiteArrow from "../assets/images/button-arrow.svg";
import { Link, useNavigate } from "react-router-dom";
import { Dropdown, Offcanvas } from "react-bootstrap";

import { useDispatch, useSelector } from "react-redux";
import { logout } from "../features/auth/authActions";
import { getPageContent } from "../features/visitor/visitorActions";
import {
  clearMessages,
  fetchBrands,
  fetchCategories,
  fetchHealthInterest,
  fetchProductsByKeyword,
} from "../features/product/productActions";
import { fetchCart } from "../features/cart/cartActions";
import { toast } from "react-toastify"; // Import toast

function Header({ mobileTitle = 'Home' }) {
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token"); //useSelector((state) => state.auth);
  const [showSidebar, setShowSidebar] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const [ourProductBoxContent, setOurProductBoxContent] = useState("");
  const [healthInterestBoxContent, setHealthInterestBoxContent] = useState("");
  const [brandBoxContent, setBrandBoxContent] = useState("");
  const [tobBarContent, setTopBarContent] = useState("");
  const [mainLogo, setMailLogo] = useState("");
  const [footerMenuContent, setFooterMenuContent] = useState(null);
  const [customPageOne, setCustomPageOne] = useState(null);
  const [customPageSecond, setCustomPageSecond] = useState(null);

  const isCartFetched = useRef(false); // Track whether cart has been fetched
  const closeMenuTimeoutRef = useRef(null);

  const handleSidebarToggle = () => setShowSidebar(!showSidebar);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { errorMessage, brands, categories, healthInterests, searchProducts } =
    useSelector((state) => state.product);
  const { pageResponse } = useSelector((state) => state.visitor);
  const { cart } = useSelector((state) => state.cart);

  // Handle search input change
  const handleSearchChange = (e) => {
    const keyword = e.target.value;
    setSearchTerm(keyword);

    // Dispatch action to fetch products by keyword
    if (keyword.trim() !== "") {
      let data = {
        page: 1,
        limit: 25,
        keyword: keyword,
      };
      dispatch(fetchProductsByKeyword(data));
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    dispatch(logout());
    navigate("/sign-in");
  };

  const handleWishList = () => {
    navigate("/profile/wishlist");
  };

  const handleMenuNavigation = () => {
    setMenuOpen(false);
    setActiveDropdown(null);
  };

  useEffect(() => {
    let data = { page: 1, limit: 20 };
    dispatch(fetchBrands(data));
    dispatch(fetchCategories(data));
    dispatch(fetchHealthInterest(data));

    let dataPage = { code: "footer" };
    dispatch(getPageContent(dataPage));

    // Only fetch the cart once
    if (!isCartFetched.current) {
      dispatch(fetchCart());
      isCartFetched.current = true; // Mark as fetched to prevent future calls
    }
  }, [dispatch]);

  useEffect(() => {

  },[cart]);

  const renderBrandRows = () => {
    if (!brands?.data?.length) return null;
    const rows = [];
    for (let i = 0; i < brands.data.length; i += 5) {
      rows.push(
        <div className="col-sm-4" key={i}>
          {brands.data.slice(i, i + 5).map((row) => (
            <Link
              to={`/products?brands=${row.slug}`}
              key={row.id}
              title={row.title}
              className="dropdown-item"
            >
              {row.title}
            </Link>
          ))}
        </div>
      );
    }
    return <>{rows}</>;
  };

  const renderCategoryRows = () => {
    const categoryList = categories?.data?.slice(0, 10); // Limit to first 10 categories
    if (!categoryList?.length) return null;

    const columns = [categoryList.slice(0, 5), categoryList.slice(5, 10)];

    return (
      <>
        {columns.map((colItems, index) => (
          <div className="col-sm-6" key={index}>
            {colItems.map((row) => (
              <Link
                to={`/products?categories=${row.slug}`}
                key={row.id}
                title={row.title}
                className="dropdown-item"
              >
                {row.title}
              </Link>
            ))}
          </div>
        ))}
      </>
    );

    /*
        if (!categories?.data?.length) return null;
        const rows = [];
        for (let i = 0; i < categories.data.length; i += 5) {
            rows.push(
                <div className="col-sm-4" key={i}>
                    {categories.data.slice(i, i + 5).map((row) => (
                        <Link
                            to={`/products?categories=${row.slug}`}
                            key={row.id}
                            title={row.title}
                            className="dropdown-item"
                        >
                            {row.title}
                        </Link>
                    ))}
                </div>
            );
        }
        return <>{rows}</>;
        */
  };

  const renderHealthInterestRows = () => {
    if (!healthInterests?.data?.length) return null;
    const rows = [];
    for (let i = 0; i < healthInterests.data.length; i += 5) {
      rows.push(
        <div className="col-sm-4" key={i}>
          {healthInterests.data.slice(i, i + 5).map((row) => (
            <Link
              to={`/products?healthInterests=${row.slug}`}
              key={row.id}
              title={row.title}
              className="dropdown-item"
            >
              {row.title}
            </Link>
          ))}
        </div>
      );
    }
    return <>{rows}</>;
  };

  useEffect(() => {
    if (errorMessage) {
      toast.error(errorMessage, { autoClose: 5000, hideProgressBar: true, className: "toast-error" });
      dispatch(clearMessages()); // Reset the messages after showing the toast
    }
  }, [errorMessage, dispatch]);

  // useEffect(() => {
  //     console.log("Header token user", token)
  // }, [token]);

  useEffect(() => {
    if (pageResponse !== null) {
      let headerContent = JSON.parse(pageResponse.footer_section);
      if (headerContent) {
        setBrandBoxContent(headerContent.brand_section);
        setHealthInterestBoxContent(
          headerContent.health_interest_advertising_section
        );
        setOurProductBoxContent(
          headerContent.order_product_advertising_section
        );
        setTopBarContent(headerContent.footer_header_text);
        setMailLogo(headerContent.main_logo);
        setFooterMenuContent(headerContent);
        setCustomPageOne(pageResponse.custom_page_1);
        setCustomPageSecond(pageResponse.custom_page_2);
        localStorage.setItem("footerSection", pageResponse.footer_section);
        localStorage.setItem(
          "customPage1",
          JSON.stringify(pageResponse.custom_page_1)
        );
        localStorage.setItem(
          "customPage2",
          JSON.stringify(pageResponse.custom_page_2)
        );
      }
    }
  }, [pageResponse]);

  const [activeDropdown, setActiveDropdown] = useState(null);
const [menuOpen, setMenuOpen] = useState(false);
const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleMouseEnter = (id) => {
    if (!isMobile) {
      if (closeMenuTimeoutRef.current) {
        clearTimeout(closeMenuTimeoutRef.current);
        closeMenuTimeoutRef.current = null;
      }
      setActiveDropdown(id);
    }
  };
  const handleMouseLeave = () => {
    if (!isMobile) {
      if (closeMenuTimeoutRef.current) {
        clearTimeout(closeMenuTimeoutRef.current);
      }
      // Small delay prevents accidental close while moving cursor into submenu.
      closeMenuTimeoutRef.current = setTimeout(() => {
        setActiveDropdown(null);
      }, 180);
    }
  };
  const handleMobileToggle = (id) => { if (isMobile) setActiveDropdown(prev => prev === id ? null : id); };

  const mobileAboutSections = [
    {
      title: "Company",
      links: [
        { to: "/about-us", label: "About Us" },
        { to: "/page/quality-transparency", label: "Quality Transparency" },
        { to: "/careers", label: "Careers" },
        ...(customPageOne ? [{ to: `/page/${customPageOne.code}`, label: customPageOne.page_name }] : []),
        ...(customPageSecond ? [{ to: `/page/${customPageSecond.code}`, label: customPageSecond.page_name }] : []),
      ],
    },
    {
      title: "Customer Support",
      links: [
        { to: "/contact-us", label: "Contact Us" },
        { to: "/page/support-center", label: "Support Center" },
        { to: "/page/shipping", label: "Shipping" },
        { to: "/page/returns", label: "Returns" },
        { to: "/faqs", label: "FAQ's" },
      ],
    },
    {
      title: "Customer Service",
      links: [
        { to: "/page/track-my-order", label: "Track My Order" },
        { to: "/page/return-policy", label: "Return Policy" },
        { to: "/page/international-shipping", label: "International Shipping" },
        { to: "/page/subscription", label: "Subscription" },
        { to: "/page/products-recalls", label: "Products Recalls" },
      ],
    },
    {
      title: "My Account",
      links: [
        { to: "/profile/my-orders", label: "Order History" },
        { to: "/profile/wishlist", label: "Wishlist" },
        { to: "/profile/return-orders", label: "Return’s Order" },
        { to: "/profile/my-subscription", label: "My Subscription" },
      ],
    },
  ];

   useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    return () => {
      if (closeMenuTimeoutRef.current) {
        clearTimeout(closeMenuTimeoutRef.current);
      }
    };
  }, []);

  return (
    <>
      <header>
        {tobBarContent ? (
          <div
            className="header-top common-padding"
            dangerouslySetInnerHTML={{ __html: tobBarContent }}
          >
            {/* <p><a href="/" title='Sign up'>Sign up</a> for our mailing list and get 15% off your first order. <a href="/" title='Terms apply'>Terms apply.</a></p> */}
          </div>
        ) : (
          // <div className='header-top common-padding'><p></p></div>
          <Skeleton height="45px" width="100%" />
        )}

       {menuOpen && <div className="menu-backdrop" onClick={() => setMenuOpen(false)} />}
        <Navbar expand="lg" className="common-padding" expanded={menuOpen} onToggle={setMenuOpen}>
          <Navbar.Brand className="header-logo">
            <Link to={"/"}>
              {mainLogo ? (
                <img 
                  src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${mainLogo}`}
                  alt=""
                />
              ) : (
                <Skeleton width={150} height={60} />
              )}
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <p className="mobile-text">{mobileTitle}</p>
          <Navbar.Collapse id="basic-navbar-nav">
            <div className="mobile-menu-header">
              <p>Menu</p>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
            </div>
            <Nav className="m-auto">
              <NavDropdown
                className="mega-menu"
                title="Our Products"
                id="shop-all"
                show={activeDropdown === 1}
                onMouseEnter={() => handleMouseEnter(1)}
                onMouseLeave={handleMouseLeave}
                onToggle={() => handleMobileToggle(1)}
              >
                <div className="mega-menu-wrap" onMouseEnter={() => handleMouseEnter(1)} onMouseLeave={handleMouseLeave}>
                  <div className="mega-menu-cols">
                    <div className="mega-menu-col col-one">
                      <h3>Categories</h3>
                      <div className="row">{renderCategoryRows()}</div>
                    </div>

                    <div className="mega-menu-col">
                      <h3>Featured</h3>
                      <Link
                        to="/products?categories=overstock"
                        data-rr-ui-dropdown-item=""
                        className="dropdown-item"
                      >
                        Overstock
                      </Link>
                      <Link
                        to="/products?categories=50-off"
                        data-rr-ui-dropdown-item=""
                        className="dropdown-item"
                      >
                        50% Off
                      </Link>
                      <Link
                        to="/products?categories=popular-products"
                        data-rr-ui-dropdown-item=""
                        className="dropdown-item"
                      >
                        Popular Products
                      </Link>
                      <Link
                        to="/products?categories=new-products"
                        data-rr-ui-dropdown-item=""
                        className="dropdown-item"
                      >
                        New Products
                      </Link>
                    </div>

                    <div className="mega-menu-col">
                      <h3>Multivitamins</h3>
                      <Link
                        to="/products?ageGroups=kids&categories=multivitamins"
                        data-rr-ui-dropdown-item=""
                        className="dropdown-item"
                      >
                        Children&nbsp;&nbsp;Multivitamins
                      </Link>
                      <Link
                        to="/products?ageGroups=teens&categories=multivitamins"
                        data-rr-ui-dropdown-item=""
                        className="dropdown-item"
                      >
                        Teens&nbsp;&nbsp;Multivitamins
                      </Link>
                      <Link
                        to="/products?ageGroups=adults&categories=multivitamins"
                        data-rr-ui-dropdown-item=""
                        className="dropdown-item"
                      >
                        Women&nbsp;&nbsp;Multivitamins
                      </Link>
                      <Link
                        to="/products?ageGroups=adults&categories=multivitamins"
                        data-rr-ui-dropdown-item=""
                        className="dropdown-item"
                      >
                        Men&nbsp;&nbsp;Multivitamins
                      </Link>
                      <Link
                        to="/products?ageGroups=adults-50&categories=multivitamins"
                        data-rr-ui-dropdown-item=""
                        className="dropdown-item"
                      >
                        Seniors&nbsp;&nbsp;Multivitamins
                      </Link>
                      <Link
                        to="/products?categories=multivitamins&ageGroups=kids"
                        data-rr-ui-dropdown-item=""
                        className="dropdown-item"
                      >
                        Prenatal&nbsp;&nbsp;Multivitamins
                      </Link>
                    </div>

                    <div className="mega-menu-col">
                      <h3>Essential Oils</h3>
                      <Link
                        to="/products?categories=stress-relief"
                        data-rr-ui-dropdown-item=""
                        className="dropdown-item"
                      >
                        Stress Relief
                      </Link>
                      <Link
                        to="/products?categories=energy-boosters"
                        data-rr-ui-dropdown-item=""
                        className="dropdown-item"
                      >
                        Energy Boosters
                      </Link>
                      <Link
                        to="/products?categories=sleep-support"
                        data-rr-ui-dropdown-item=""
                        className="dropdown-item"
                      >
                        Sleep Support
                      </Link>
                      <Link
                        to="/products?categories=immune-support"
                        data-rr-ui-dropdown-item=""
                        className="dropdown-item"
                      >
                        Immune Support
                      </Link>
                    </div>

                    {ourProductBoxContent && (
                      <div className="mega-menu-col col-two menu-advertisement">
                        <img
                          className="w-100"
                          src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${ourProductBoxContent.image}`}
                          alt=""
                        />
                        <div className="advertisement-details">
                          <span>{ourProductBoxContent.title}</span>
                          <h2>{ourProductBoxContent.short_title}</h2>
                          <p>{ourProductBoxContent.description}</p>
                          <a
                            href={ourProductBoxContent.btn_url}
                            className="cutsom-bttn"
                          >
                            {ourProductBoxContent.btn_title}{" "}
                            <img src={whiteArrow} alt="" />
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </NavDropdown>
              <NavDropdown
                className="mega-menu"
                title="Health Interests"
                id="health-interests"
                show={activeDropdown === 2}
                onMouseEnter={() => handleMouseEnter(2)}
                onMouseLeave={handleMouseLeave}
                onToggle={() => handleMobileToggle(2)}
              >
                <div className="mega-menu-wrap" onMouseEnter={() => handleMouseEnter(2)} onMouseLeave={handleMouseLeave}>
                  <div className="mega-menu-cols">
                    <div className="mega-menu-col col-three">
                      <h3>Health Interests</h3>
                      <div className="row">{renderHealthInterestRows()}</div>
                    </div>
                    {healthInterestBoxContent && (
                      <div className="mega-menu-col col-two menu-advertisement">
                        <img
                          className="w-100"
                          src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${healthInterestBoxContent.image}`}
                          alt=""
                        />
                        <div className="advertisement-details">
                          <span>{healthInterestBoxContent.title}</span>
                          <h2>{healthInterestBoxContent.short_title}</h2>
                          <p>{healthInterestBoxContent.description}</p>
                          <a
                            href={healthInterestBoxContent.btn_url}
                            className="cutsom-bttn"
                          >
                            {healthInterestBoxContent.btn_title}{" "}
                            <img src={whiteArrow} alt="" />
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </NavDropdown>
              <NavDropdown
                className="mega-menu"
                title="Brands"
                id="brands"
                show={activeDropdown === 3}
                onMouseEnter={() => handleMouseEnter(3)}
                onMouseLeave={handleMouseLeave}
                onToggle={() => handleMobileToggle(3)}
              >
                <div className="mega-menu-wrap" onMouseEnter={() => handleMouseEnter(3)} onMouseLeave={handleMouseLeave}>
                  <div className="mega-menu-cols">
                    <div className="mega-menu-col col-three">
                      <h3>Our Brands</h3>
                      <div className="row">{renderBrandRows()}</div>
                      {/* <Row dangerouslySetInnerHTML={{__html: renderBrandRows()}}></Row> */}
                    </div>

                    {brandBoxContent && (
                      <div className="mega-menu-col col-two menu-advertisement">
                        <img
                          className="w-100"
                          src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${brandBoxContent.image}`}
                          alt=""
                        />
                        <div className="advertisement-details">
                          <span>{brandBoxContent.title}</span>
                          <h2>{brandBoxContent.short_title}</h2>
                          <p>{brandBoxContent.description}</p>
                          <a
                            href={brandBoxContent.btn_url}
                            className="cutsom-bttn"
                          >
                            {brandBoxContent.btn_title}{" "}
                            <img src={whiteArrow} alt="" />
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </NavDropdown>

              <Nav.Link className="mobile-menu-link-spaced" title="Blogs" as={Link} to="/blogs">
                Blogs
              </Nav.Link>
              <NavDropdown
                className="mega-menu d-md-none about-mobile-dropdown"
                title="About"
                id="about-mobile-menu"
                show={activeDropdown === 4}
                onMouseEnter={() => handleMouseEnter(4)}
                onMouseLeave={handleMouseLeave}
                onToggle={() => handleMobileToggle(4)}
              >
                <div className="mega-menu-wrap">
                  <div className="mega-menu-cols">
                    <div className="mega-menu-col mobile-about-contact">
                      {(mainLogo || footerMenuContent?.bottom_logo) && (
                        <Link to="/" className="mobile-about-logo" onClick={handleMenuNavigation}>
                          <img
                            src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${mainLogo || footerMenuContent.bottom_logo}`}
                            alt={footerMenuContent.company_name}
                          />
                        </Link>
                      )}
                      {footerMenuContent?.footer_address && <p>{footerMenuContent.footer_address}</p>}
                      {footerMenuContent?.office_phone_no && (
                        <a href={`tel:${footerMenuContent.office_phone_no}`}>{footerMenuContent.office_phone_no}</a>
                      )}
                      {footerMenuContent?.info_email && (
                        <a href={`mailto:${footerMenuContent.info_email}`}>{footerMenuContent.info_email}</a>
                      )}
                    </div>

                    {mobileAboutSections.map((section) => (
                      <div className="mega-menu-col mobile-about-links" key={section.title}>
                        <h3>{section.title}</h3>
                        {section.links.map((link) => (
                          <Link
                            key={link.to}
                            to={link.to}
                            data-rr-ui-dropdown-item=""
                            className="dropdown-item"
                            onClick={handleMenuNavigation}
                          >
                            {link.label}
                          </Link>
                        ))}
                      </div>
                    ))}

                    <div className="mega-menu-col mobile-about-legal">
                      <div className="mobile-about-legal-links">
                        <Link to="/page/terms-conditions" onClick={handleMenuNavigation}>Terms & Conditions</Link>
                        <Link to="/page/privacy-policy" onClick={handleMenuNavigation}>Privacy Policy</Link>
                        <Link to="/page/legal" onClick={handleMenuNavigation}>Legal</Link>
                        <Link to="/page/return-policy" onClick={handleMenuNavigation}>Return Policy</Link>
                      </div>
                      {footerMenuContent?.footer_copyright_text && (
                        <div
                          className="mobile-about-copyright"
                          dangerouslySetInnerHTML={{
                            __html: footerMenuContent.footer_copyright_text,
                          }}
                        />
                      )}
                      <ul className="mobile-about-social">
                        {footerMenuContent?.facebook_url && (
                          <li><a href={footerMenuContent.facebook_url} target="_blank" rel="noopener noreferrer"><img src={Facebook} alt="Facebook" /></a></li>
                        )}
                        {footerMenuContent?.twitter_url && (
                          <li><a href={footerMenuContent.twitter_url} target="_blank" rel="noopener noreferrer"><img src={Twitter} alt="Twitter" /></a></li>
                        )}
                        {footerMenuContent?.linkedin_url && (
                          <li><a href={footerMenuContent.linkedin_url} target="_blank" rel="noopener noreferrer"><img src={Linkedin} alt="LinkedIn" /></a></li>
                        )}
                        {footerMenuContent?.instagram_url && (
                          <li><a href={footerMenuContent.instagram_url} target="_blank" rel="noopener noreferrer"><img src={Instagram} alt="Instagram" /></a></li>
                        )}
                        {footerMenuContent?.youtube_url && (
                          <li><a href={footerMenuContent.youtube_url} target="_blank" rel="noopener noreferrer"><img src={Youtube} alt="YouTube" /></a></li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </NavDropdown>
              <Nav.Link className="mobile-menu-link-spaced d-none d-md-flex" title="About" as={Link} to="/about-us">
                About
              </Nav.Link>
              <Nav.Link className="mobile-menu-link-spaced" title="Contact Us" as={Link} to="/contact-us">
                Contact Us
              </Nav.Link>
              {token === null ? (
                <Nav.Link className="mobile-menu-link-spaced d-flex d-md-none" title="Sign In" as={Link} to="/sign-in">
                  Sign In
                </Nav.Link>
              ) : (
                <Nav.Link className="mobile-menu-link-spaced d-flex d-md-none" title="Logout" as={Link} to="/sign-in" onClick={handleLogout}>
                  Logout
                </Nav.Link>
              )}
            </Nav>
            <Nav className="header-right">
              <Nav.Link
                className="header-icon mobile-hide"
                href="#"
                onClick={handleSidebarToggle}
              >
                <img src={Search} alt="" />
              </Nav.Link>
              <Nav.Link
                className="header-icon header-cart-link mobile-hide"
                as={Link}
                to="/cart"
              >
                <img src={Cart} alt="cart" />
                {cart?.length > 0 && (
                  <span className="cart-count">{cart.length}</span>
                )}
              </Nav.Link>
              {token === null ? (
                <Nav.Link className="header-icon mobile-hide" as={Link} to="/sign-in">
                  <img src={User} alt="sign-in" />
                </Nav.Link>
              ) : (
                <>
                  <Nav.Link className="header-icon mobile-hide" onClick={handleWishList}>
                    <img src={Like} alt="wish-list" />
                  </Nav.Link>
                  <Dropdown className="mobile-hide">
                    <Dropdown.Toggle id="dropdown-basic">
                      <img className="w-100" src={User} alt="" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu align={{ lg: "end" }}>
                      <Dropdown.Item as={Link} to="/profile">
                        Profile
                      </Dropdown.Item>
                      {/* <Dropdown.Item href="#">Setting</Dropdown.Item> */}
                      <Dropdown.Item onClick={handleLogout}>
                        Logout
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </header>
      <Offcanvas
        show={showSidebar}
        onHide={handleSidebarToggle}
        placement="end"
        className="custom-offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Search Products</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="search-box">
            <form method="get">
              <label className="searchbutton" for="searchright">
                <img src={SidebarSearchIcon} alt="" />
              </label>
              <input
                className="search-input"
                id="searchright"
                type="search"
                placeholder="Search"
                value={searchTerm}
                onChange={handleSearchChange}
              />
            </form>
            <ul>
              {/* Loop through searchProducts and display them */}
              {searchTerm.trim() !== "" ? (
                searchProducts && searchProducts.length > 0 ? (
                  searchProducts.map((product) => (
                    <li key={product.id}>
                      <a
                        href={`/products/${product.slug}`}
                        className="search-item"
                      >
                        <div className="search-item-img">
                          <img
                            src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${product.image}`}
                            alt={product.title}
                          />
                        </div>
                        <div className="search-item-text">
                          <h3>{product.title}</h3>
                          <p>
                            {product.short_description ||
                              "No description available."}
                          </p>
                        </div>
                      </a>
                    </li>
                  ))
                ) : (
                  <li>No products found</li>
                )
              ) : (
                <li>Type to search products</li>
              )}
            </ul>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
export default Header;
